/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { createSlice } from '@reduxjs/toolkit'

/**********************************************************************************************************
  *    SLICE
  **********************************************************************************************************/
export const supportSlice = createSlice({
    name: 'support',
    initialState: {
        supportOpen: false
    },
    reducers: {
        setSupportOpen: (state, { payload }) => {
            state.supportOpen = payload
        }
    }
})

export const {
    setSupportOpen
} = supportSlice.actions

export default supportSlice.reducer
